<template>
	<btn class="btn--style--fill--white btn--state--none global-region-indicator">
		<span class="global-region-indicator__icon grunticon grunticon--globe"></span>
		<span class="global-region-indicator__region">{{region}}</span>
	</btn>
</template>

<script>
import Btn from '../atoms/Btn'

export default {
	name: 'GlobalRegionIndicator',
	components: {
		Btn
	},
	props: {
		region: String,
	},
	computed: {
	},
	mounted: function() {
	},
	methods: {
	}
}
</script>

<style lang="scss">
	@import "src/scss/toolkit";

	$c: ".global-region-indicator";
	#{$c}
	{
		padding-left: 0px;
		padding-right: rem(16);

		&__icon
		{
			padding-top: 0px;
			padding-bottom: 0px;
		}

		&__region
		{
			color: palette(blue);
			padding-left: rem(8);
		}
	}

</style>



// WEBPACK FOOTER //
// src/components/atoms/GlobalRegionIndicator.vue